export default __webpack_public_path__ + "static/media/durvis-17-min.2e3a12f2.jpg";